import { Component, Injector, OnInit, Input, ViewChild } from '@angular/core';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import {
    ChangeUserLanguageDto,
    CompaniesServiceProxy,
    GetLocationForEditOutput,
    GetLocationForViewDto,
    LocationCompanyLookupTableDto,
    LocationDto,
    LocationsServiceProxy,
    ProfileServiceProxy,
    UserServiceProxy,
    UserToLocationInput,
} from '@shared/service-proxies/service-proxies';
import { filter as _filter } from 'lodash-es';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { LazyLoadEvent } from '@node_modules/primeng/api';
import { Paginator } from '@node_modules/primeng/paginator';
import { Table } from '@node_modules/primeng/table';

@Component({
    selector: 'location-switch',
    templateUrl: './location-switch.component.html',
    standalone: false,
})
export class LocationSwitchComponent extends ThemesLayoutBaseComponent implements OnInit {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;
    locations: GetLocationForViewDto[] = [];
    totalRecords = 0;
    loading = false;
    filterText = '';
    selectedCompanyId: number | undefined;
    selectedLocationId: number | undefined;
    defaultLocation: string = '';
    display = false;
    companies: [] = [];
    companyName = '';

    allCompanys: LocationCompanyLookupTableDto[];

    companyNameFilter = '';

    constructor(
        injector: Injector,
        _dateTimeService: DateTimeService,
        private _locationService: LocationsServiceProxy,
        private _userService: UserServiceProxy,
        private _companyService: CompaniesServiceProxy,
    ) {
        super(injector, _dateTimeService);
    }

    ngOnInit(): void {
        this._locationService.getAllCompanyForTableDropdown().subscribe((result) => {
            this.allCompanys = result;
        });
    }

    show(): void {
        this.display = true;
        this.getLocations({});
    }

    getLocations(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();

        this._locationService
            .getAll(
                this.filterText,
                this.companyNameFilter,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    onSearchChange(): void {
        this.getLocations({});
    }

    selectLocation(location: LocationDto): void {
        var dto = new UserToLocationInput();
        dto.userId = this.appSession.userId;
        dto.locationId = location.id;
        this._userService.changeUserLocation(dto).subscribe(() => {
            this.notify.success(this.l('Default location updated'));
            this.display = false;
            window.location.reload();
        });
    }
}
